import { render, staticRenderFns } from "./flowNegativeWriteoffListComponent.vue?vue&type=template&id=b839e574&scoped=true&"
import script from "./flowNegativeWriteoffListComponent.vue?vue&type=script&lang=js&"
export * from "./flowNegativeWriteoffListComponent.vue?vue&type=script&lang=js&"
import style0 from "./flowNegativeWriteoffListComponent.vue?vue&type=style&index=0&id=b839e574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b839e574",
  null
  
)

export default component.exports